//This is set in package.json "homepage": "https://www.meted.ucar.edu/etc/etc"
export const withBase = (path) => `${process.env.PUBLIC_URL || ''}${path}`;